import { render, staticRenderFns } from "./UmDbCardList.vue?vue&type=template&id=ce87258c&"
import script from "./UmDbCardList.vue?vue&type=script&lang=js&"
export * from "./UmDbCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports